<div #container ngDraggable [handle]="dragHandle" class="container flex column">
  <div #dragHandle class="flex row space-between header">
    <div class="flex column justify-center">
      <h2>
        <a
          *ngIf="vm.selectedJob?.mediaId"
          [href]="'/mam/editMedia/' + vm.selectedJob.mediaId"
          >{{ vm.selectedJob?.mediaName }}</a
        >
        <ng-container *ngIf="!vm.selectedJob?.mediaId">{{
          vm.selectedJob?.mediaName
        }}</ng-container>
        - Report
      </h2>
    </div>
    <div class="flex row justify-center window-buttons">
      <evrideo-x-button
        (mousedown)="vm.closeReport()"
        [overrideStyle]="{
          'margin-top': '-0.11vw',
          width: '1.15vw',
          height: '1.15vw'
        }"
      ></evrideo-x-button>
    </div>
  </div>
  <div class="flex column body">
    <ng-container
      *ngIf="!vm.selectedLogJson && !vm.reportError"
    >
      <div class="report-loading flex row fill-height justify-center">
        <p class="report-loading-message">{{ loadingMessage }}</p>
      </div>
    </ng-container>

    <ng-container *ngIf="vm.reportError">
      <div class="report-loading flex row fill-height justify-center">
        <p class="report-loading-message report-error">{{ vm.reportError }}</p>
      </div>
    </ng-container>

    <ng-container *ngIf="vm.selectedLogJson">
      <div class="log-summary" *ngIf="vm.selectedLogSummary as summary">
        <p><strong>Status:</strong> {{ summary.status || '—' }}</p>
        <p><strong>Mode:</strong> {{ summary.mode || '—' }}</p>
        <p *ngIf="summary.videosBucketPath">
          <strong>Videos path:</strong> {{ summary.videosBucketPath }}
        </p>
        <p *ngIf="summary.metadataBucketPath">
          <strong>Metadata path:</strong> {{ summary.metadataBucketPath }}
        </p>
        <p *ngIf="summary.errors.length">
          <strong>Errors:</strong>
          <span *ngFor="let err of summary.errors; let last = last">
            {{ err }}<span *ngIf="!last">; </span>
          </span>
        </p>
        <p *ngIf="summary.warnings.length">
          <strong>Warnings:</strong>
          <span *ngFor="let warn of summary.warnings; let last = last">
            {{ warn }}<span *ngIf="!last">; </span>
          </span>
        </p>
        <table class="stages-table" *ngIf="summary.stages.length">
          <thead>
            <tr>
              <th>Stage</th>
              <th>Duration (ms)</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let stage of summary.stages">
              <td>{{ stage.name }}</td>
              <td>{{ stage.durationMs }}</td>
              <td>{{ stage.status }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <pre class="log-json">{{ vm.selectedLogJson }}</pre>
    </ng-container>
  </div>
</div>
